var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartOfDga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.83333,
    stroke: "#E89A3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912_2165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0661 8.25642L21.0764 8.25129H21.0815L15.9994 5.33334L10.92 8.25129H10.9148L10.9328 8.25898L6.75586 10.6667V21.3333L15.9994 26.6667L25.243 21.3333V10.6667L21.0661 8.25642ZM15.2482 24.5026L11.5789 22.3846L8.25586 20.4445V16.918V12.4333L15.2482 16.4667V24.5026ZM8.97894 11.1154L12.4328 9.12052L15.9995 7.11112L19.561 9.1154L23.0277 11.1154L16.0046 15.1667L8.97894 11.1154ZM23.743 16.9308V20.4445L20.4405 22.3718L16.7507 24.5V16.4718L23.743 12.4385V16.9308Z",
    fill: "#E89A3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912_2165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(5.33301 5.33334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartOfDga);
export default __webpack_public_path__ + "static/media/part_of_dga.d3af63dd295e7c51e9e11c2034acd701.svg";
export { ForwardRef as ReactComponent };